import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { getOr } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Container, Dropdown, Icon } from 'rsuite';
import MainLayout from '../../../containers/MainLayout';
import MainContent from '../../MainContent';
import SidebarNav from '../../SidebarNav';
import DropdownItemLink from '../../DropdownItemLink';
import {
  outreachAggregateReportPath,
  outreachAggregateReportHistoryPath,
  visitHistoryReportPath
} from '../../../routes/Paths';
import {
  getSidebarNavExpanded,
  getDropdownNavOpenKeys
} from '../../../redux/selectors/components/reports/page-layout';
import {
  toggleSidebarNav,
  toggleDropdownNavItem,
  resetDropdownNavItems
} from '../../../redux/actions/components/reports/page-layout';
import { getUserPermissionsAsMap } from '../../../redux/selectors/permission';
import { VISIT_HISTORY_REPORT } from '../../../constants/permissions';
import { hasViewAccess } from '../../../helpers/permission';
import NAV_KEYS, { navKeysByPath } from './nav-keys';

const PageLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { path } = useRouteMatch();
  const [activeKey, setActiveKey] = useState();
  const sidebarExpanded = useSelector(getSidebarNavExpanded);
  const navOpenKeys = useSelector(getDropdownNavOpenKeys);
  const permissions = useSelector(getUserPermissionsAsMap);

  useEffect(
    () => {
      const navKey = getOr('', path, navKeysByPath);
      setActiveKey(navKey);
    },
    [path]
  );

  const handleToggleSidebarNav = () => {
    dispatch(toggleSidebarNav());
    if (sidebarExpanded) {
      dispatch(resetDropdownNavItems());
    }
  };

  const handleToggleDropdownNav = navItem => {
    dispatch(toggleDropdownNavItem(navItem));
  };

  return (
    <MainLayout>
      <MainContent>
        <SidebarNav
          activeKey={activeKey}
          expanded={sidebarExpanded}
          onToggle={handleToggleSidebarNav}
          openKeys={navOpenKeys}
        >
          {hasViewAccess(VISIT_HISTORY_REPORT, permissions) && (
            <Dropdown
              title="Guest"
              icon={<Icon icon="user-analysis" />}
              eventKey={NAV_KEYS.GUEST_REPORT}
              placement="rightStart"
              onClick={() => {
                handleToggleDropdownNav(NAV_KEYS.GUEST_REPORT);
              }}
            >
              <DropdownItemLink
                to={visitHistoryReportPath}
                eventKey={NAV_KEYS.VISIT_HISTORY}
              >
                <Icon icon="list-alt" /> Association VHR
              </DropdownItemLink>
            </Dropdown>
          )}
          <Dropdown
            title="Outreach Aggregate"
            icon={<Icon icon="list-ul" />}
            eventKey={NAV_KEYS.OUTREACH_AGGREGATE}
            placement="rightStart"
            onClick={() => {
              handleToggleDropdownNav(NAV_KEYS.OUTREACH_AGGREGATE);
            }}
          >
            <DropdownItemLink
              to={outreachAggregateReportPath}
              eventKey={NAV_KEYS.GENERATE_REPORT}
            >
              <Icon icon="file" /> Generate Report
            </DropdownItemLink>
            <DropdownItemLink
              to={outreachAggregateReportHistoryPath}
              eventKey={NAV_KEYS.DOWNLOAD_HISTORY}
            >
              <Icon icon="list-alt" /> Report History
            </DropdownItemLink>
          </Dropdown>
        </SidebarNav>
        <Container>{children}</Container>
      </MainContent>
    </MainLayout>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default PageLayout;
